window.BD_initProductGallery = function () {
    const roots = document.querySelectorAll('.product-hero');
    if (!roots.length) return;

    roots.forEach((root) => {
        if (!root || root.dataset.galleryBound) return;

        const mainEl = root.querySelector('[data-role="main-swiper"]');
        if (!mainEl) return;

        const thumbsEl = root.querySelector('[data-role="thumbs-swiper"]');
        root.dataset.galleryBound = '1';

        let mediaData = [];
        let mediaDataEl = root.querySelector('script[id^="MediaData-"]') || document.querySelector('script[id^="MediaData-"]');
        if (mediaDataEl) {
            try { mediaData = JSON.parse(mediaDataEl.textContent || '[]'); } catch (_) { }
        }
        if (!mediaData.length) {
            mediaData = Array.from(root.querySelectorAll('[data-media-id]')).map((el, i) => ({
                id: String(el.getAttribute('data-media-id')),
                index: Number(el.getAttribute('data-index') ?? i),
                alt: el.getAttribute('alt') || ''
            }));
        }
        const mediaIndexById = Object.fromEntries(mediaData.map(m => [String(m.id), m.index]));

        const thumbs = thumbsEl ? new Swiper(thumbsEl, {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlidesBounds: false,
            centeredSlides: false,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            observer: false,
            observeParents: false
        }) : null;

        const paginationEl = root.querySelector('.main-swiper-pagination');

        const main = new Swiper(mainEl, {
            spaceBetween: 12,
            preloadImages: false,
            lazy: true,
            keyboard: { enabled: true },
            navigation: {
                nextEl: root.querySelector('.swiper-button-next'),
                prevEl: root.querySelector('.swiper-button-prev'),
            },
            thumbs: thumbs ? { swiper: thumbs } : undefined,
            pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined

        });
        function ensureThumbVisible(idx) {
            if (!thumbs) return;
            thumbs.slideTo(idx, 300, false);
        }

        main.on('slideChange', () => ensureThumbVisible(main.activeIndex));
        main.on('slideChangeTransitionEnd', () => ensureThumbVisible(main.activeIndex));

        let variants = [];
        const variantsEl = root.querySelector('script[id^="VariantData-"]') || document.querySelector('script[id^="VariantData-"]');
        if (variantsEl) {
            try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (_) { }
        }

        const findVariantById = (id) => variants.find(v => String(v.id) === String(id));
        const guessMediaIdForVariant = (variant) => {
            if (variant?.featured_media?.id) return String(variant.featured_media.id);
            return null;
        };
        const getIndexForVariant = (variant) => {
            const mediaId = guessMediaIdForVariant(variant);
            if (!mediaId) return null;
            const idx = mediaIndexById[mediaId];
            return typeof idx === 'number' ? idx : null;
        };
        const slideToVariant = (variant) => {
            const idx = getIndexForVariant(variant);
            if (idx === null) return false;
            main.slideTo(idx);
            if (thumbs) thumbs.slideTo(idx);
            return true;
        };

        const idInput = root.querySelector('input[name="id"]') || document.querySelector('.formVariantId[name="id"]');
        if (idInput) {
            idInput.addEventListener('change', () => {
                const v = findVariantById(idInput.value);
                if (v) slideToVariant(v);
            });
        }
        document.addEventListener('variant:change', (e) => {
            if (!e.detail || !e.detail.variant) return;
            slideToVariant(e.detail.variant);
        });

        function syncThumbsHeight() {
            if (!thumbsEl) return;
            thumbsEl.style.height = mainEl.clientHeight + 'px';
        }
        main.on('imagesReady', syncThumbsHeight);
        main.on('resize', syncThumbsHeight);
        window.addEventListener('resize', () => requestAnimationFrame(syncThumbsHeight));
        syncThumbsHeight();

        if (idInput) {
            const initial = findVariantById(idInput.value);
            if (initial) slideToVariant(initial);
        }
        const mqDesktop = window.matchMedia('(min-width:1024px)');


        const setHeroImgVar = () => {
            if (!mqDesktop.matches) { root.style.removeProperty('--hero-img-height'); return; }
            const slide = main.slides[main.activeIndex] || main.slides[0];
            const el = slide ? (slide.querySelector('picture img, img, video')) : null;
            const h = (el && el.clientHeight) || mainEl.clientHeight || 0;
            root.style.setProperty('--hero-img-height', h + 'px');
        };

        main.on('imagesReady', setHeroImgVar);
        main.on('slideChangeTransitionEnd', setHeroImgVar);
        main.on('resize', setHeroImgVar);
        window.addEventListener('resize', () => requestAnimationFrame(setHeroImgVar));
        Array.from(mainEl.querySelectorAll('img')).forEach(img => img.addEventListener('load', setHeroImgVar));
        setHeroImgVar();
    });


};

document.addEventListener('DOMContentLoaded', window.BD_initProductGallery);
document.addEventListener('shopify:section:load', window.BD_initProductGallery);





(function () {
    const roots = document.querySelectorAll('.product-hero');
    if (!roots.length) return;

    roots.forEach(root => {
        if (root.dataset.pickersBound) return;
        root.dataset.pickersBound = '1';

        const variantsEl = root.querySelector('script[id^="VariantData-"]') || document.querySelector('script[id^="VariantData-"]');
        let variants = [];
        try { variants = JSON.parse(variantsEl?.textContent || '[]'); } catch (_) { }

        const metaEl = root.querySelector('script[id^="VariantMeta-"]') || document.querySelector('script[id^="VariantMeta-"]');
        let vmeta = {};
        try { vmeta = JSON.parse(metaEl?.textContent || '{}'); } catch (_) { }

        const idInput = root.querySelector('.formVariantId[name="id"]') || root.querySelector('input[name="id"]');
        const atc = root.querySelector('#addToCart');
        const preorderInput = root.querySelector('#preorder_date');
        const preLbl = root.querySelector('.pre_order_label');
        const preLblSpan = preLbl ? preLbl.querySelector('span') : null;

        const colorBtns = Array.from(root.querySelectorAll('.product-swatch[data-color]'));
        const sizeBtns = Array.from(root.querySelectorAll('.size-option[data-size]'));

        const colorLabel = root.querySelector('#selected-color-label');
        const sizeLabel = root.querySelector('#selected-size-label');

        if (!idInput || !variants.length) return;


        const productIdAttr = root.querySelector('[data-product-id]')?.getAttribute('data-product-id') || '';

        function writeVariantToUrl(variantId) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', String(variantId));
            history.replaceState(null, '', url.toString());
        }
        function readVariantFromUrl() {
            const url = new URL(window.location.href);
            const v = url.searchParams.get('variant');
            return v ? String(v) : null;
        }
        function storageKey(productId) {
            return `bd:pdp:lastVariant:${productId || ''}`;
        }

        const byId = id => variants.find(v => String(v.id) === String(id));
        const vFor = (color, size) => variants.find(v => (v.option1 || '') === (size || '') && (v.option2 || '') === (color || ''));
        const metaFor = v => (v && vmeta[String(v.id)]) || {};

        const normalizeISO = (v) => {
            if (v == null || v === '') return '';
            const d = new Date(String(v).trim());
            if (isNaN(d)) return '';
            const y = d.getUTCFullYear();
            const m = String(d.getUTCMonth() + 1).padStart(2, '0');
            const day = String(d.getUTCDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };
        const isFutureISO = (iso) => {
            if (!iso) return false;
            const d = new Date(iso + 'T00:00:00Z');
            return !isNaN(d) && d.getTime() > Date.now();
        };
        const fmtMMDDYYYY = (iso) => {
            if (!iso) return '';
            const d = new Date(iso + 'T00:00:00Z');
            if (isNaN(d)) return '';
            const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
            const dd = String(d.getUTCDate()).padStart(2, '0');
            const yyyy = d.getUTCFullYear();
            return `${mm}-${dd}-${yyyy}`;
        };
        const fmtMMDDYYYYSlash = (iso) => {
            if (!iso) return '';
            const d = new Date(iso + 'T00:00:00Z');
            if (isNaN(d)) return '';
            const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
            const dd = String(d.getUTCDate()).padStart(2, '0');
            const yyyy = d.getUTCFullYear();
            return `${mm}/${dd}/${yyyy}`;
        };


        function setSelected(list, el) { list.forEach(b => b.classList.toggle('is-selected', b === el)); }

        function refreshSizeButtons(color) {
            sizeBtns.forEach(btn => {
                const sz = btn.getAttribute('data-size') || '';
                const v = vFor(color, sz);
                const avail = !!(v && v.available);
                btn.classList.toggle('size__unavailable', !avail);
                // btn.toggleAttribute('disabled', !avail);
                btn.setAttribute('data-available', avail ? 'true' : 'false');
                const m = metaFor(v);
                const iso = normalizeISO(m.preorder_date);
                const pre = isFutureISO(iso);
                btn.dataset.preorder = pre ? 'true' : 'false';
                btn.setAttribute('data-preorder', pre ? 'true' : 'false');
                if (pre) btn.setAttribute('pre-order-date', iso); else btn.removeAttribute('pre-order-date');
            });
        }

        function getPreorderISO(variant, sizeBtn) {
            const m = metaFor(variant);
            let iso = normalizeISO(m.preorder_date);
            if (!isFutureISO(iso) && sizeBtn) {
                const attr = sizeBtn.getAttribute('pre-order-date') || '';
                const attrISO = normalizeISO(attr);
                if (isFutureISO(attrISO)) iso = attrISO; else iso = '';
            }
            return iso && isFutureISO(iso) ? iso : '';
        }

        function applyATC(variant, sizeBtn) {
            if (!atc) return;
            const soldOut = !variant || !variant.available;
            const iso = getPreorderISO(variant, sizeBtn);
            const isPre = !!iso;

            if (soldOut) {
                atc.disabled = true; atc.value = 'Sold out'; atc.removeAttribute('data-preorder'); atc.classList.add('is-soldout'); atc.classList.remove('is-preorder');
            } else if (isPre) {
                atc.disabled = false; atc.value = 'Pre-order'; atc.setAttribute('data-preorder', 'true'); atc.classList.add('is-preorder'); atc.classList.remove('is-soldout');
            } else {
                atc.disabled = false; atc.value = 'Add to cart'; atc.removeAttribute('data-preorder'); atc.classList.remove('is-preorder', 'is-soldout');
            }
            if (preorderInput) preorderInput.value = isPre ? fmtMMDDYYYY(iso) : '';

            if (preLbl) {
                if (isPre) {
                    preLbl.classList.add('show_pre_order_date');
                    if (preLblSpan) preLblSpan.textContent = fmtMMDDYYYYSlash(iso);
                } else {
                    preLbl.classList.remove('show_pre_order_date');
                    if (preLblSpan) preLblSpan.textContent = '';
                }
            }

        }

        function commitVariant(variant, colorBtn, sizeBtn) {
            if (!variant) return;
            idInput.value = variant.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
            if (colorLabel) colorLabel.textContent = variant.option2 || '';
            if (sizeLabel) sizeLabel.textContent = variant.option1 || '';
            if (colorBtn) setSelected(colorBtns, colorBtn);
            if (sizeBtn) setSelected(sizeBtns, sizeBtn);
            applyATC(variant, sizeBtn);

            writeVariantToUrl(variant.id);
            try { sessionStorage.setItem(storageKey(productIdAttr), String(variant.id)); } catch (_) { }
        }

        let selectedColor = null;
        let selectedSize = null;

        (function initFromCurrent() {
            const urlVarId = readVariantFromUrl();
            let current = urlVarId ? byId(urlVarId) : null;

            if (!current) {
                try {
                    const storedId = sessionStorage.getItem(storageKey(productIdAttr));
                    if (storedId) current = byId(storedId);
                } catch (_) { }
            }

            if (!current) current = byId(idInput.value) || variants[0];
            if (!current) return;

            selectedColor = current.option2 || null;
            selectedSize = current.option1 || null;

            const cBtn = colorBtns.find(b => (b.getAttribute('data-color') || '') === (selectedColor || ''));
            const sBtn = sizeBtns.find(b => (b.getAttribute('data-size') || '') === (selectedSize || ''));

            refreshSizeButtons(selectedColor);
            commitVariant(current, cBtn, sBtn);
        })();


        colorBtns.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                const color = btn.getAttribute('data-color') || '';
                if (!color) return;
                if (!variants.some(v => (v.option2 || '') === color)) return;
                selectedColor = color;
                refreshSizeButtons(selectedColor);
                let target = vFor(selectedColor, selectedSize);
                if (!target || !target.available) {
                    const firstAvail = variants.find(v => (v.option2 || '') === selectedColor && !!v.available);
                    const fall = firstAvail || variants.find(v => (v.option2 || '') === selectedColor);
                    if (!fall) return;
                    selectedSize = fall.option1 || null;
                    const sBtn = sizeBtns.find(b => (b.getAttribute('data-size') || '') === (selectedSize || ''));
                    target = fall;
                    commitVariant(target, btn, sBtn);
                } else {
                    const sBtn = sizeBtns.find(b => (b.getAttribute('data-size') || '') === (selectedSize || ''));
                    commitVariant(target, btn, sBtn);
                }
            });
        });

        sizeBtns.forEach(btn => {
            btn.addEventListener('click', e => {
                e.preventDefault();
                if (btn.hasAttribute('disabled')) return;
                const size = btn.getAttribute('data-size') || '';
                if (!size) return;
                selectedSize = size;
                const target = vFor(selectedColor, selectedSize) || vFor(selectedColor, size) || variants.find(v => (v.option1 || '') === size);
                if (!target) return;
                commitVariant(target, colorBtns.find(b => (b.getAttribute('data-color') || '') === (selectedColor || '')), btn);
            });
        });

        idInput.addEventListener('change', () => {
            const v = byId(idInput.value);
            if (!v) return;
            selectedColor = v.option2 || null;
            selectedSize = v.option1 || null;
            const cBtn = colorBtns.find(b => (b.getAttribute('data-color') || '') === (selectedColor || ''));
            const sBtn = sizeBtns.find(b => (b.getAttribute('data-size') || '') === (selectedSize || ''));
            setSelected(colorBtns, cBtn || null);
            setSelected(sizeBtns, sBtn || null);
            refreshSizeButtons(selectedColor);
            applyATC(v, sBtn || null);
            if (colorLabel) colorLabel.textContent = v.option2 || '';
            if (sizeLabel) sizeLabel.textContent = v.option1 || '';
        });
    });
})();









document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-accordion]').forEach(acc => {
        const triggers = Array.from(acc.querySelectorAll('.pdp-accordion__trigger'));

        function open(panel, btn) {
            panel.removeAttribute('hidden');
            panel.style.height = '0px';
            panel.offsetHeight;
            panel.style.height = panel.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');

            const onEnd = () => {
                panel.style.height = 'auto';
                panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd, { once: true });
        }

        function close(panel, btn) {
            const current = panel.style.height;
            if (getComputedStyle(panel).height === 'auto' || current === 'auto' || !current) {
                panel.style.height = panel.scrollHeight + 'px';
                panel.offsetHeight;
            }
            panel.style.height = '0px';
            btn.setAttribute('aria-expanded', 'false');

            const onEnd = () => {
                panel.setAttribute('hidden', '');
                panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd, { once: true });
        }

        triggers.forEach(btn => {
            const panel = document.getElementById(btn.getAttribute('aria-controls'));
            panel.setAttribute('hidden', '');
            btn.setAttribute('aria-expanded', 'false');

            btn.addEventListener('click', () => {
                const isOpen = btn.getAttribute('aria-expanded') === 'true';

                triggers.forEach(b => {
                    if (b === btn) return;
                    const p = document.getElementById(b.getAttribute('aria-controls'));
                    if (p && b.getAttribute('aria-expanded') === 'true') close(p, b);
                });

                if (isOpen) close(panel, btn);
                else open(panel, btn);
            });
        });

        const ro = new ResizeObserver(() => {
            const openBtn = triggers.find(b => b.getAttribute('aria-expanded') === 'true');
            if (!openBtn) return;
            const p = document.getElementById(openBtn.getAttribute('aria-controls'));
            if (!p || p.hasAttribute('hidden')) return;
            p.style.height = 'auto';
        });
        acc.querySelectorAll('.pdp-accordion__panel').forEach(p => ro.observe(p));
    });
});









// Special Sizes MODAL Script
(function () {
    const modal = document.querySelector('.bd-size-modal');
    const openBtn = document.querySelector('.bd-open-size-modal');
    if (!modal || !openBtn) return;

    const closeBtn = modal.querySelector('.bd-size-modal__close');
    const sizeGrid = modal.querySelector('.bd-size-grid');
    const stockMsg = modal.querySelector('.bd-stock-msg');
    const addBtn = modal.querySelector('.bd-add-to-bag');
    const addBtnText = addBtn.querySelector('span') || addBtn;
    const form = modal.querySelector('.bd-contact-form');
    const hiddenColor = modal.querySelector('.bd-hidden-color');
    const hiddenSize = modal.querySelector('.bd-hidden-size');

    const product = JSON.parse(modal.dataset.productJson || '{}');
    let extraSizes = [];
    try { extraSizes = JSON.parse(modal.dataset.extraSizes || '[]'); } catch (e) { }

    function getQty() {
        const el = document.querySelector('.formQty,[name="quantity"]');
        const n = el ? parseInt(el.value, 10) : 1;
        return Number.isFinite(n) && n > 0 ? n : 1;
    }

    function getCurrentVariant() {
        const idInput = document.querySelector('input.formVariantId[name="id"], input[name="id"].formVariantId, input[name="id"][type="hidden"]');
        const selectEl = document.querySelector('select[name="id"]');
        const currentVarId = (idInput && idInput.value) ? idInput.value : (selectEl && selectEl.value ? selectEl.value : null);
        if (currentVarId) {
            const v = product.variants.find(x => String(x.id) === String(currentVarId));
            if (v) return v;
        }
        return product.variants[0] || null;
    }

    function getCurrentColor() {
        const v = getCurrentVariant();
        if (!v) return '';
        const names = (product.options || []).map(o => String(o).toLowerCase());
        const colorIdx = Math.max(0, names.findIndex(n => ['color', 'colour', 'shade', 'tone'].some(k => n.includes(k))));
        return [v.option1, v.option2, v.option3][colorIdx] || '';
    }

    function variantFor(size, color) {
        if ((product.options || []).length >= 2) {
            return product.variants.find(v => v.option1 === size && (v.option2 || '') === color) || null;
        }
        return product.variants.find(v => v.option1 === size) || null;
    }

    function uniq(arr) { return [...new Set(arr)]; }

    function syncPDPVariant(variant, size) {
        const pdpBtn = Array.from(document.querySelectorAll('.size-option'))
            .find(b => (b.dataset.size || '').trim() === String(size).trim());

        if (pdpBtn && !pdpBtn.classList.contains('is-selected')) {
            pdpBtn.click();
        }

        const idInput = document.querySelector('input.formVariantId[name="id"], input[name="id"].formVariantId, input[name="id"][type="hidden"]');
        if (idInput && variant && String(idInput.value) !== String(variant.id)) {
            idInput.value = variant.id;
            idInput.dispatchEvent(new Event('input', { bubbles: true }));
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const sizeLabel = document.getElementById('selected-size-label');
        if (sizeLabel) sizeLabel.textContent = size;

        document.querySelectorAll('.size-option').forEach(b => {
            b.classList.toggle('is-selected', (b.dataset.size || '') === String(size));
        });
    }

    let selectedVariantId = null;
    let selectedState = null;

    function openModal() {
        sizeGrid.innerHTML = '';
        stockMsg.hidden = true;
        addBtn.hidden = true;
        addBtn.classList.remove('is-disabled');
        addBtnText.textContent = 'Add to Bag';
        form.hidden = true;

        const color = getCurrentColor();
        hiddenColor.value = color || '';

        const variantsForColor = (product.options || []).length >= 2
            ? product.variants.filter(v => (v.option2 || '') === color)
            : product.variants;

        const productSizes = uniq(variantsForColor.map(v => v.option1));
        const displaySizes = uniq([...extraSizes, ...productSizes]);

        displaySizes.forEach(size => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'bd-size-btn btn btn--primary';
            btn.dataset.size = size;

            const span = document.createElement('span');
            span.textContent = size;
            btn.appendChild(span);

            const v0 = variantFor(size, color);
            if (v0 && !v0.available) btn.classList.add('is-oos');
            if (!v0) btn.classList.add('is-special');

            btn.addEventListener('click', () => onSelect(size));
            sizeGrid.appendChild(btn);
        });

        modal.classList.remove('hidden');
        modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
        modal.classList.add('hidden');
        modal.setAttribute('aria-hidden', 'true');
    }

    function onSelect(size) {
        const color = getCurrentColor();
        const variant = variantFor(size, color);

        syncPDPVariant(variant, size);
        hiddenColor.value = color || '';
        hiddenSize.value = size;

        sizeGrid.querySelectorAll('.bd-size-btn').forEach(b => {
            b.classList.toggle('is-selected', b.dataset.size === size);
        });

        let status;
        if (!variant) status = 'special';
        else status = variant.available ? 'in' : 'oos';

        selectedState = status;
        selectedVariantId = variant ? variant.id : null;

        stockMsg.hidden = false;

        if (status === 'in') {
            // IN STOCK → ATC vidljiv
            form.hidden = true;
            addBtn.hidden = false;
            addBtn.classList.remove('is-disabled');
            addBtnText.textContent = 'Add to Bag';
            stockMsg.textContent = 'IN STOCK — you can add this size to your bag.';
            stockMsg.style.color = '#1a7f37';
        } else {
            // OOS i SPECIAL → isto ponašanje: prikaži formu, sakrij ATC
            addBtn.hidden = true;
            addBtn.classList.remove('is-disabled');
            addBtnText.textContent = 'Add to Bag';
            form.hidden = false;

            stockMsg.textContent =
                status === 'oos'
                    ? 'OUT OF STOCK — send an inquiry and we’ll check availability.'
                    : 'SPECIAL ORDER — size not in stock. Send an inquiry.';
            stockMsg.style.color = status === 'oos' ? '#b30000' : '#b35600';
        }
    }

    addBtn.addEventListener('click', async () => {
        if (addBtn.classList.contains('is-disabled')) return;
        if (selectedState !== 'in' || !selectedVariantId) return;

        const qty = getQty();
        addBtn.disabled = true;
        try {
            const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: selectedVariantId, quantity: qty })
            });
            if (!res.ok) throw new Error('Cart add failed');

            document.dispatchEvent(new CustomEvent('cart:updated'));
            addBtnText.textContent = 'Added!';
            setTimeout(() => { addBtnText.textContent = 'Add to Bag'; addBtn.disabled = false; closeModal(); }, 900);
            setTimeout(() => {
                const trigger = document.querySelector('.js-mini-cart-trigger');
                if (trigger) trigger.click();
            }, 1000);
        } catch (e) {
            addBtn.disabled = false;
            alert('Error adding to cart. Please try again.');
        }
    });

    openBtn.addEventListener('click', openModal);
    modal.querySelector('.bd-size-modal__backdrop').addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
})();


// // BIS MODAL Script
// (function () {
//     const modal = document.querySelector('.bd-bis-modal');
//     const openBtn = document.querySelector('.bd-open-bis-modal');
//     if (!modal || !openBtn) return;

//     const closeBtn = modal.querySelector('.bd-size-modal__close');
//     const sizeGrid = modal.querySelector('.bd-bis-size-grid');
//     const stockMsg = modal.querySelector('.bd-stock-msg');
//     const form = modal.querySelector('.bd-bis-form');
//     const emailInput = modal.querySelector('.bd-bis-email');
//     const addBtn = modal.querySelector('.bd-bis-add-to-bag');
//     const addBtnText = addBtn.querySelector('span') || addBtn;

//     const hiddenColor = modal.querySelector('.bd-bis-hidden-color');
//     const hiddenSize = modal.querySelector('.bd-bis-hidden-size');
//     const hiddenVar = modal.querySelector('.bd-bis-hidden-variant');
//     const hiddenVarT = modal.querySelector('.bd-bis-hidden-variant-title');

//     const product = JSON.parse(modal.dataset.productJson || '{}');

//     function getQty() {
//         const el = document.querySelector('.formQty,[name="quantity"]');
//         const n = el ? parseInt(el.value, 10) : 1;
//         return Number.isFinite(n) && n > 0 ? n : 1;
//     }

//     function getCurrentVariant() {
//         const idInput = document.querySelector('input.formVariantId[name="id"], input[name="id"].formVariantId, input[name="id"][type="hidden"]');
//         const selectEl = document.querySelector('select[name="id"]');
//         const currentVarId = (idInput && idInput.value) ? idInput.value : (selectEl && selectEl.value ? selectEl.value : null);
//         if (currentVarId) {
//             const v = product.variants.find(x => String(x.id) === String(currentVarId));
//             if (v) return v;
//         }
//         return product.variants[0] || null;
//     }

//     function getCurrentColor() {
//         const v = getCurrentVariant();
//         if (!v) return '';
//         const names = (product.options || []).map(o => String(o).toLowerCase());
//         const colorIdx = Math.max(0, names.findIndex(n => ['color', 'colour', 'shade', 'tone'].some(k => n.includes(k))));
//         return [v.option1, v.option2, v.option3][colorIdx] || '';
//     }

//     function variantsForColor(color) {
//         return (product.options || []).length >= 2
//             ? product.variants.filter(v => (v.option2 || '') === color)
//             : product.variants;
//     }

//     let selectedVariantId = null;
//     let selectedState = null;

//     function openModal() {
//         sizeGrid.innerHTML = '';
//         stockMsg.hidden = true;
//         form.hidden = true;
//         addBtn.hidden = true;
//         addBtn.classList.remove('is-disabled');
//         addBtnText.textContent = 'Add to Bag';

//         const color = getCurrentColor();
//         hiddenColor.value = color || '';

//         const vList = variantsForColor(color);
//         const sizes = [...new Set(vList.map(v => v.option1))];

//         sizes.forEach(size => {
//             const v0 = vList.find(v => v.option1 === size);
//             const btn = document.createElement('button');
//             btn.type = 'button';
//             btn.className = 'bd-size-btn btn btn--primary';
//             btn.textContent = size;
//             if (v0 && !v0.available) btn.classList.add('is-oos');
//             btn.addEventListener('click', () => onSelect(size));
//             sizeGrid.appendChild(btn);
//         });

//         modal.classList.remove('hidden');
//         modal.setAttribute('aria-hidden', 'false');
//     }

//     function closeModal() {
//         modal.classList.add('hidden');
//         modal.setAttribute('aria-hidden', 'true');
//     }

//     function onSelect(size) {
//         const color = getCurrentColor();
//         const vList = variantsForColor(color);
//         const variant = vList.find(v => v.option1 === size) || null;

//         hiddenColor.value = color || '';
//         hiddenSize.value = size;
//         hiddenVar.value = variant ? variant.id : '';
//         if (hiddenVarT) hiddenVarT.value = variant ? variant.title : '';

//         sizeGrid.querySelectorAll('.bd-size-btn').forEach(b => {
//             b.classList.toggle('is-selected', b.textContent === size);
//         });

//         const status = variant && variant.available ? 'in' : 'oos';
//         selectedState = status;
//         selectedVariantId = variant ? variant.id : null;

//         stockMsg.hidden = false;

//         if (status === 'in') {
//             form.hidden = true;
//             addBtn.hidden = false;
//             addBtn.classList.remove('is-disabled');
//             addBtnText.textContent = 'Add to Bag';
//             stockMsg.textContent = 'IN STOCK — you can add this size to your bag.';
//             stockMsg.style.color = '#1a7f37';
//         } else {
//             addBtn.hidden = true;
//             form.hidden = false;
//             stockMsg.textContent = 'OUT OF STOCK — leave your email and we’ll notify you.';
//             stockMsg.style.color = '#b30000';
//         }
//     }

//     addBtn.addEventListener('click', async () => {
//         if (selectedState !== 'in' || !selectedVariantId) return;

//         const qty = getQty();
//         addBtn.disabled = true;
//         try {
//             const res = await fetch('/cart/add.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
//                 body: JSON.stringify({ id: selectedVariantId, quantity: qty })
//             });
//             if (!res.ok) throw new Error('Cart add failed');

//             document.dispatchEvent(new CustomEvent('cart:updated'));
//             addBtnText.textContent = 'Added!';
//             setTimeout(() => { addBtnText.textContent = 'Add to Bag'; addBtn.disabled = false; closeModal(); }, 900);
//             setTimeout(() => {
//                 const trigger = document.querySelector('.js-mini-cart-trigger');
//                 if (trigger) trigger.click();
//             }, 1000);
//         } catch (e) {
//             addBtn.disabled = false;
//             alert('Error adding to cart. Please try again.');
//         }
//     });

//     form.addEventListener('submit', (e) => {
//         if (!hiddenSize.value || !emailInput.value) {
//             e.preventDefault();
//             return;
//         }
//     });

//     openBtn.addEventListener('click', openModal);
//     modal.querySelector('.bd-size-modal__backdrop').addEventListener('click', closeModal);
//     closeBtn.addEventListener('click', closeModal);
// })();
